import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { CameraIcon, FileTextIcon, CheckCircleIcon, ClockIcon, ArrowRightIcon, StarIcon, SparklesIcon, TrendingUpIcon, ShieldCheckIcon } from 'lucide-react';
import ServiceBookingModal from '../components/ServiceBookingModal';
const ServicesPage = () => {
  const [selectedService, setSelectedService] = useState<'photography' | 'valuation' | null>(null);
  const [bookingModal, setBookingModal] = useState<{
    isOpen: boolean;
    serviceType: 'photography' | 'valuation';
    packageName: string;
    price: number;
  }>({
    isOpen: false,
    serviceType: 'photography',
    packageName: '',
    price: 0
  });
  const photographyPackages = [{
    id: 'basic',
    name: 'Pacote Básico',
    price: 199,
    features: ['Até 15 fotos profissionais', 'Fotos internas e externas', 'Edição básica e correção de cor', 'Entrega em 24 horas', 'Arquivos digitais em alta resolução'],
    popular: false,
    icon: '📸'
  }, {
    id: 'premium',
    name: 'Pacote Premium',
    price: 349,
    features: ['Até 30 fotos profissionais', 'Fotos internas, externas e aéreas com drone', 'Edição avançada e processamento HDR', 'Fotos crepusculares virtuais', 'Entrega em 12 horas', 'Arquivos digitais em alta resolução', 'Criação de tour virtual'],
    popular: true,
    icon: '✨'
  }, {
    id: 'luxury',
    name: 'Pacote Luxo',
    price: 599,
    features: ['Fotos profissionais ilimitadas', 'Cobertura completa interna, externa e aérea', 'Edição premium e retoque', 'Fotos crepusculares e dia para noite', 'Entrega em 6 horas', 'Arquivos digitais em alta resolução', 'Tour virtual 3D com plantas baixas', 'Vídeo walkthrough (2-3 minutos)', 'Consulta dedicada com fotógrafo'],
    popular: false,
    icon: '👑'
  }];
  const valuationServices = [{
    id: 'standard',
    name: 'Avaliação Padrão',
    price: 299,
    features: ['Relatório certificado de avaliação', 'Análise de mercado e comparáveis', 'Avaliação do estado do imóvel', 'Verificação de conformidade legal', 'Entrega em 3-5 dias úteis', 'Válido por 6 meses'],
    turnaround: '3-5 dias úteis',
    icon: '📋'
  }, {
    id: 'express',
    name: 'Avaliação Expressa',
    price: 449,
    features: ['Relatório certificado de avaliação', 'Análise abrangente de mercado', 'Inspeção detalhada do imóvel', 'Verificação de conformidade legal', 'Processamento prioritário', 'Entrega em 24-48 horas', 'Válido por 6 meses', 'Uma revisão gratuita'],
    turnaround: '24-48 horas',
    icon: '⚡'
  }];
  const handleBookService = (serviceType: 'photography' | 'valuation', packageName: string, price: number) => {
    setBookingModal({
      isOpen: true,
      serviceType,
      packageName,
      price
    });
  };
  return <div className="bg-gray-50 min-h-screen w-full" data-id="element-1098">
      {/* Hero Section - Enhanced with Better Contrast */}
      <section className="relative bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 py-20 overflow-hidden" data-id="element-1099">
        {/* Animated Background Pattern */}
        <div className="absolute inset-0 opacity-5" data-id="element-1100">
          <div className="absolute top-0 left-0 w-96 h-96 bg-primary rounded-full blur-3xl animate-pulse-slow" data-id="element-1101"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-accent rounded-full blur-3xl animate-pulse-slow" style={{
          animationDelay: '1s'
        }} data-id="element-1102"></div>
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-white rounded-full blur-3xl" data-id="element-1103"></div>
        </div>

        {/* Accent Line */}
        <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-primary via-accent to-primary" data-id="element-1104"></div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1105">
          <div className="text-center" data-id="element-1106">
            <div className="inline-flex items-center bg-primary/20 backdrop-blur-sm border border-primary/30 px-5 py-2.5 rounded-full mb-8 shadow-lg" data-id="element-1107">
              <SparklesIcon className="h-5 w-5 text-primary mr-2" data-id="element-1108" />
              <span className="text-white font-semibold text-sm" data-id="element-1109">
                Serviços Profissionais Kredita
              </span>
            </div>
            <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight" data-id="element-1110">
              Eleve Seus Anúncios ao
              <br data-id="element-1111" />
              <span className="text-white drop-shadow-[0_0_30px_rgba(16,120,114,0.8)]" data-id="element-1112">
                Próximo Nível
              </span>
            </h1>
            <p className="text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto mb-10 leading-relaxed" data-id="element-1113">
              Fotografia profissional e avaliações certificadas para destacar
              seu imóvel
            </p>
            <div className="flex flex-wrap justify-center gap-4" data-id="element-1114">
              <button onClick={() => setSelectedService('photography')} className="bg-primary hover:bg-[rgb(var(--color-primary-dark))] text-white font-bold px-8 py-4 rounded-xl transition-all duration-200 shadow-lg hover:shadow-2xl hover:scale-105 flex items-center" data-id="element-1115">
                <CameraIcon className="h-5 w-5 mr-2" data-id="element-1116" />
                Ver Fotografia
              </button>
              <button onClick={() => setSelectedService('valuation')} className="bg-white/10 backdrop-blur-sm border-2 border-white/30 text-white hover:bg-white/20 font-bold px-8 py-4 rounded-xl transition-all duration-200 flex items-center" data-id="element-1117">
                <FileTextIcon className="h-5 w-5 mr-2" data-id="element-1118" />
                Ver Avaliação
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-12 bg-white border-b border-gray-200" data-id="element-1119">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1120">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-1121">
            <div className="text-center" data-id="element-1122">
              <div className="text-4xl font-bold text-primary mb-2" data-id="element-1123">500+</div>
              <div className="text-gray-600" data-id="element-1124">Imóveis Fotografados</div>
            </div>
            <div className="text-center" data-id="element-1125">
              <div className="text-4xl font-bold text-primary mb-2" data-id="element-1126">98%</div>
              <div className="text-gray-600" data-id="element-1127">Satisfação dos Clientes</div>
            </div>
            <div className="text-center" data-id="element-1128">
              <div className="text-4xl font-bold text-primary mb-2" data-id="element-1129">24h</div>
              <div className="text-gray-600" data-id="element-1130">Entrega Média</div>
            </div>
            <div className="text-center" data-id="element-1131">
              <div className="text-4xl font-bold text-primary mb-2" data-id="element-1132">100%</div>
              <div className="text-gray-600" data-id="element-1133">Conformidade Legal</div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Overview - Enhanced */}
      <section className="py-20" data-id="element-1134">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1135">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-20" data-id="element-1136">
            {/* Photography Service */}
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-3xl shadow-xl overflow-hidden group hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1" data-id="element-1137">
              <div className="relative h-72 overflow-hidden" data-id="element-1138">
                <img src="https://images.unsplash.com/photo-1554995207-c18c203602cb?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80" alt="Professional Photography" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-1139" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" data-id="element-1140"></div>
                <div className="absolute bottom-6 left-6 right-6" data-id="element-1141">
                  <div className="flex items-center mb-3" data-id="element-1142">
                    <div className="w-16 h-16 bg-white rounded-2xl flex items-center justify-center shadow-lg" data-id="element-1143">
                      <CameraIcon className="h-8 w-8 text-primary" data-id="element-1144" />
                    </div>
                  </div>
                  <h2 className="text-3xl font-bold text-white mb-2" data-id="element-1145">
                    Fotografia Profissional
                  </h2>
                  <p className="text-white/90 text-sm" data-id="element-1146">Imagens que vendem</p>
                </div>
              </div>
              <div className="p-8" data-id="element-1147">
                <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-1148">
                  Destaque seu imóvel com fotos impressionantes e de alta
                  qualidade que atraem mais compradores e aumentam o engajamento
                  em até 80%.
                </p>
                <ul className="space-y-3 mb-8" data-id="element-1149">
                  <li className="flex items-start" data-id="element-1150">
                    <CheckCircleIcon className="h-5 w-5 text-green-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-1151" />
                    <span className="text-sm text-gray-700" data-id="element-1152">
                      Equipamento e iluminação profissional
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-1153">
                    <CheckCircleIcon className="h-5 w-5 text-green-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-1154" />
                    <span className="text-sm text-gray-700" data-id="element-1155">
                      Fotografia aérea com drone disponível
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-1156">
                    <CheckCircleIcon className="h-5 w-5 text-green-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-1157" />
                    <span className="text-sm text-gray-700" data-id="element-1158">
                      Entrega rápida (6-24 horas)
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-1159">
                    <CheckCircleIcon className="h-5 w-5 text-green-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-1160" />
                    <span className="text-sm text-gray-700" data-id="element-1161">
                      Tours virtuais e vídeos walkthrough
                    </span>
                  </li>
                </ul>
                <button onClick={() => setSelectedService('photography')} className="w-full bg-primary hover:bg-[rgb(var(--color-primary-dark))] text-white font-bold py-4 px-6 rounded-xl transition-all duration-200 flex items-center justify-center group shadow-lg hover:shadow-xl" data-id="element-1162">
                  Ver Pacotes
                  <ArrowRightIcon className="h-5 w-5 ml-2 transform group-hover:translate-x-1 transition-transform" data-id="element-1163" />
                </button>
              </div>
            </div>

            {/* Valuation Service */}
            <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-3xl shadow-xl overflow-hidden group hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1" data-id="element-1164">
              <div className="relative h-72 overflow-hidden" data-id="element-1165">
                <img src="https://images.unsplash.com/photo-1450101499163-c8848c66ca85?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80" alt="Property Valuation" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-1166" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" data-id="element-1167"></div>
                <div className="absolute bottom-6 left-6 right-6" data-id="element-1168">
                  <div className="flex items-center mb-3" data-id="element-1169">
                    <div className="w-16 h-16 bg-white rounded-2xl flex items-center justify-center shadow-lg" data-id="element-1170">
                      <FileTextIcon className="h-8 w-8 text-green-600" data-id="element-1171" />
                    </div>
                  </div>
                  <h2 className="text-3xl font-bold text-white mb-2" data-id="element-1172">
                    Avaliação de Imóveis
                  </h2>
                  <p className="text-white/90 text-sm" data-id="element-1173">
                    Certificada e confiável
                  </p>
                </div>
              </div>
              <div className="p-8" data-id="element-1174">
                <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-1175">
                  Obtenha avaliações certificadas de profissionais licenciados,
                  totalmente em conformidade com as regulamentações legais e
                  aceitas por todas as instituições financeiras.
                </p>
                <ul className="space-y-3 mb-8" data-id="element-1176">
                  <li className="flex items-start" data-id="element-1177">
                    <CheckCircleIcon className="h-5 w-5 text-green-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-1178" />
                    <span className="text-sm text-gray-700" data-id="element-1179">
                      Certificado por avaliadores licenciados
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-1180">
                    <CheckCircleIcon className="h-5 w-5 text-green-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-1181" />
                    <span className="text-sm text-gray-700" data-id="element-1182">
                      Relatórios legalmente conformes
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-1183">
                    <CheckCircleIcon className="h-5 w-5 text-green-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-1184" />
                    <span className="text-sm text-gray-700" data-id="element-1185">
                      Aceito por bancos e credores
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-1186">
                    <CheckCircleIcon className="h-5 w-5 text-green-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-1187" />
                    <span className="text-sm text-gray-700" data-id="element-1188">
                      Análise abrangente de mercado
                    </span>
                  </li>
                </ul>
                <button onClick={() => setSelectedService('valuation')} className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-6 rounded-xl transition-all duration-200 flex items-center justify-center group shadow-lg hover:shadow-xl" data-id="element-1189">
                  Ver Opções
                  <ArrowRightIcon className="h-5 w-5 ml-2 transform group-hover:translate-x-1 transition-transform" data-id="element-1190" />
                </button>
              </div>
            </div>
          </div>

          {/* Photography Packages */}
          {selectedService === 'photography' && <div className="mb-20 animate-fadeIn" data-id="element-1191">
              <div className="text-center mb-12" data-id="element-1192">
                <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-1193">
                  Pacotes de Fotografia
                </h2>
                <p className="text-lg text-gray-600" data-id="element-1194">
                  Escolha o pacote perfeito para seu imóvel
                </p>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1195">
                {photographyPackages.map(pkg => <div key={pkg.id} className={`relative bg-white rounded-2xl shadow-lg overflow-hidden transition-all duration-300 hover:shadow-2xl hover:-translate-y-2 ${pkg.popular ? 'ring-2 ring-primary scale-105' : ''}`} data-id="element-1196">
                    {pkg.popular && <div className="absolute top-0 right-0 bg-gradient-to-r from-accent to-orange-500 text-white text-xs font-bold px-4 py-2 rounded-bl-xl shadow-lg" data-id="element-1197">
                        ⭐ Mais Popular
                      </div>}
                    <div className="p-8" data-id="element-1198">
                      <div className="text-5xl mb-4" data-id="element-1199">{pkg.icon}</div>
                      <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-1200">
                        {pkg.name}
                      </h3>
                      <div className="mb-6" data-id="element-1201">
                        <span className="text-5xl font-bold text-primary" data-id="element-1202">
                          ${pkg.price}
                        </span>
                        <span className="text-gray-600 ml-2" data-id="element-1203">por sessão</span>
                      </div>
                      <ul className="space-y-3 mb-8" data-id="element-1204">
                        {pkg.features.map((feature, index) => <li key={index} className="flex items-start" data-id="element-1205">
                            <CheckCircleIcon className="h-5 w-5 text-green-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-1206" />
                            <span className="text-sm text-gray-700" data-id="element-1207">
                              {feature}
                            </span>
                          </li>)}
                      </ul>
                      <button onClick={() => handleBookService('photography', pkg.name, pkg.price)} className={`w-full font-bold py-4 px-6 rounded-xl transition-all duration-200 shadow-lg hover:shadow-xl ${pkg.popular ? 'bg-primary hover:bg-[rgb(var(--color-primary-dark))] text-white' : 'bg-gray-100 hover:bg-gray-200 text-gray-900'}`} data-id="element-1208">
                        Reservar Agora
                      </button>
                    </div>
                  </div>)}
              </div>
            </div>}

          {/* Valuation Services */}
          {selectedService === 'valuation' && <div className="mb-20 animate-fadeIn" data-id="element-1209">
              <div className="text-center mb-12" data-id="element-1210">
                <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-1211">
                  Serviços de Avaliação
                </h2>
                <p className="text-lg text-gray-600" data-id="element-1212">
                  Avaliações certificadas por profissionais licenciados
                </p>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-1213">
                {valuationServices.map(service => <div key={service.id} className="bg-white rounded-2xl shadow-lg p-8 hover:shadow-2xl transition-all duration-300 hover:-translate-y-2" data-id="element-1214">
                    <div className="text-5xl mb-4" data-id="element-1215">{service.icon}</div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-1216">
                      {service.name}
                    </h3>
                    <div className="mb-4" data-id="element-1217">
                      <span className="text-5xl font-bold text-primary" data-id="element-1218">
                        ${service.price}
                      </span>
                    </div>
                    <div className="flex items-center text-sm text-gray-600 mb-6 bg-blue-50 px-4 py-3 rounded-xl w-fit" data-id="element-1219">
                      <ClockIcon className="h-5 w-5 mr-2 text-primary" data-id="element-1220" />
                      <span className="font-medium" data-id="element-1221">{service.turnaround}</span>
                    </div>
                    <ul className="space-y-3 mb-8" data-id="element-1222">
                      {service.features.map((feature, index) => <li key={index} className="flex items-start" data-id="element-1223">
                          <CheckCircleIcon className="h-5 w-5 text-green-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-1224" />
                          <span className="text-sm text-gray-700" data-id="element-1225">
                            {feature}
                          </span>
                        </li>)}
                    </ul>
                    <button onClick={() => handleBookService('valuation', service.name, service.price)} className="w-full bg-primary hover:bg-[rgb(var(--color-primary-dark))] text-white font-bold py-4 px-6 rounded-xl transition-all duration-200 shadow-lg hover:shadow-xl" data-id="element-1226">
                      Solicitar Avaliação
                    </button>
                  </div>)}
              </div>
            </div>}

          {/* Legal Compliance Notice - Enhanced */}
          <div className="bg-gradient-to-r from-blue-50 to-blue-100 border-2 border-blue-200 rounded-2xl p-8 max-w-4xl mx-auto shadow-lg" data-id="element-1227">
            <div className="flex items-start" data-id="element-1228">
              <div className="w-14 h-14 bg-primary rounded-2xl flex items-center justify-center flex-shrink-0 shadow-lg" data-id="element-1229">
                <ShieldCheckIcon className="h-7 w-7 text-white" data-id="element-1230" />
              </div>
              <div className="ml-6" data-id="element-1231">
                <h3 className="text-2xl font-bold text-gray-900 mb-3" data-id="element-1232">
                  Serviços Legalmente Conformes
                </h3>
                <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-1233">
                  Todos os nossos serviços de avaliação de imóveis são
                  conduzidos por avaliadores licenciados e certificados em total
                  conformidade com as regulamentações locais e federais. Nossos
                  relatórios são aceitos por:
                </p>
                <ul className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm text-gray-700" data-id="element-1234">
                  <li className="flex items-center" data-id="element-1235">
                    <CheckCircleIcon className="h-5 w-5 text-green-500 mr-2" data-id="element-1236" />
                    Bancos e instituições financeiras
                  </li>
                  <li className="flex items-center" data-id="element-1237">
                    <CheckCircleIcon className="h-5 w-5 text-green-500 mr-2" data-id="element-1238" />
                    Órgãos governamentais
                  </li>
                  <li className="flex items-center" data-id="element-1239">
                    <CheckCircleIcon className="h-5 w-5 text-green-500 mr-2" data-id="element-1240" />
                    Processos legais
                  </li>
                  <li className="flex items-center" data-id="element-1241">
                    <CheckCircleIcon className="h-5 w-5 text-green-500 mr-2" data-id="element-1242" />
                    Autoridades fiscais
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials - Enhanced */}
      <section className="py-20 bg-white" data-id="element-1243">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1244">
          <div className="text-center mb-12" data-id="element-1245">
            <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-1246">
              O Que Nossos Clientes Dizem
            </h2>
            <p className="text-lg text-gray-600" data-id="element-1247">
              Confiado por proprietários de imóveis em todo o país
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1248">
            {[{
            name: 'Sarah Mitchell',
            role: 'Proprietária de Imóvel',
            text: 'A fotografia profissional fez uma enorme diferença. Meu anúncio teve 3x mais visualizações e vendeu em duas semanas!',
            rating: 5,
            avatar: '👩'
          }, {
            name: 'James Rodriguez',
            role: 'Corretor de Imóveis',
            text: 'O relatório de avaliação foi abrangente e aceito pelo banco imediatamente. Economizou semanas de idas e vindas.',
            rating: 5,
            avatar: '👨'
          }, {
            name: 'Emily Chen',
            role: 'Vendedora',
            text: 'Serviço excepcional! As fotos ficaram deslumbrantes e todo o processo foi perfeito. Altamente recomendado.',
            rating: 5,
            avatar: '👩‍💼'
          }].map((testimonial, index) => <div key={index} className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1" data-id="element-1249">
                <div className="flex items-center mb-4" data-id="element-1250">
                  {[...Array(testimonial.rating)].map((_, i) => <StarIcon key={i} className="h-5 w-5 text-yellow-500 fill-yellow-500" data-id="element-1251" />)}
                </div>
                <p className="text-gray-700 mb-6 italic leading-relaxed" data-id="element-1252">
                  "{testimonial.text}"
                </p>
                <div className="flex items-center" data-id="element-1253">
                  <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center text-2xl mr-4" data-id="element-1254">
                    {testimonial.avatar}
                  </div>
                  <div data-id="element-1255">
                    <p className="font-bold text-gray-900" data-id="element-1256">
                      {testimonial.name}
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-1257">{testimonial.role}</p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* CTA Section - Enhanced */}
      <section className="py-20 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 relative overflow-hidden" data-id="element-1258">
        <div className="absolute inset-0 opacity-5" data-id="element-1259">
          <div className="absolute top-0 left-0 w-96 h-96 bg-primary rounded-full blur-3xl animate-pulse-slow" data-id="element-1260"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-accent rounded-full blur-3xl animate-pulse-slow" style={{
          animationDelay: '1s'
        }} data-id="element-1261"></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1262">
          <h2 className="text-4xl font-bold text-white mb-6" data-id="element-1263">
            Pronto para Melhorar Seu Anúncio?
          </h2>
          <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto" data-id="element-1264">
            Reserve nossos serviços profissionais hoje e faça seu imóvel se
            destacar
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-1265">
            <button onClick={() => setSelectedService('photography')} className="inline-block bg-primary hover:bg-[rgb(var(--color-primary-dark))] text-white font-bold px-8 py-4 rounded-xl transition-all duration-200 shadow-lg hover:shadow-2xl hover:scale-105" data-id="element-1266">
              Reservar Fotografia
            </button>
            <button onClick={() => setSelectedService('valuation')} className="inline-block bg-white/10 backdrop-blur-sm border-2 border-white/30 text-white hover:bg-white/20 font-bold px-8 py-4 rounded-xl transition-all duration-200" data-id="element-1267">
              Solicitar Avaliação
            </button>
          </div>
        </div>
      </section>

      {/* Booking Modal */}
      <ServiceBookingModal isOpen={bookingModal.isOpen} onClose={() => setBookingModal({
      ...bookingModal,
      isOpen: false
    })} serviceType={bookingModal.serviceType} packageName={bookingModal.packageName} price={bookingModal.price} data-id="element-1268" />
    </div>;
};
export default ServicesPage;